import WidgetContext from 'embed_v2/components/Context'
import useDebounce from 'embed_v2/hooks/useDebounce'
import { useState, useEffect, useCallback, useContext } from 'preact/hooks'
import { ElementReminderOptions } from 'core/types/element/element_reminder'
import optionsPropTypes from 'PropsSpec'
import Input from '../common/Input'

const STYLES = {
  width: '100%',
  height: '100%'
}

type Props = {
  options: ElementReminderOptions['phone']
  placeholder: string
}

const Phone = (props: Props) => {
  const { options } = props
  const [value, setValue] = useState('')
  const { viewer, setViewerField } = useContext(WidgetContext)

  const debouncedChangeHandler = useDebounce(setViewerField)

  useEffect(() => {
    if (viewer.phone?.length) {
      setValue(viewer.phone)
    }
  }, [viewer.phone])

  const onChange = useCallback((val: string) => {
    setValue(val)
    debouncedChangeHandler('phone', val)
  }, [])

  return (
    <div style={STYLES} className="wf_reset wf_field wf_phone_wrapper">
      <Input value={value} onChange={onChange} options={options} placeholder={props.placeholder} name="phone" />
    </div>
  )
}

Phone.propTypes = {
  options: optionsPropTypes('phone')
}

export default Phone
